import { useContext } from "react";
import useSWR from "swr";
import { environment } from "../config/environment";
import { TokenContext } from "../context/TokenContext";
import { swrFetcher } from "../services/queries";
import { BusinessTenant } from "@attelas/shared";

export const useTenants = () => {
  const { token } = useContext(TokenContext);

  const { data, isLoading, error, mutate } = useSWR<{
    businessTenants: BusinessTenant[];
  }>(
    `${environment.apiUrl}/api/organisation/business-tenants`,
    (url: string) => swrFetcher(url, { headers: { Authorization: `Bearer ${token}` } }),
    {}
  );

  return {
    tenants: data?.businessTenants ?? [],
    isLoading,
    isError: !!error,
    refetchTenants: () => mutate(),
  };
};
